/* global window, document, URL, Blob */

import * as R from 'ramda';

export default function DownloadDocumentDirectiveController(
  $q,

  alerts,
  orgDataService
) {
  const vm = this;

  vm.iconType = vm.iconType || 'file_download';
  vm.iconSizeClass = vm.iconSizeClass || 'md-36';
  vm.iconColorClass = vm.iconColorClass || 'fc-navanta-charcoal-75';
  vm.handleDownloadClick = _handleDownloadClick;
  vm.createClass = _createClass;

  function _createClass() {
    return `${vm.iconSizeClass} ${vm.iconColorClass}`;
  }

  function _handleDownloadClick() {
    const downloadResponse = $q.defer();
    if (vm.ssApp === 'theSentry') {
      orgDataService.downloadDocumentForCustomer(vm.documentId, vm.atCustomerId).then((downloadDocumentResponse) => {
        downloadResponse.resolve(downloadDocumentResponse);
      });
    } else if (vm.ssApp === 'theSafe') {
      orgDataService.downloadDocument(vm.documentId).then((downloadDocumentResponse) => {
        downloadResponse.resolve(downloadDocumentResponse);
      });
    }
    downloadResponse.promise.then((responseData) => {
      if (vm.cleanseDownloadName) {
        cleanseDownloadName();
      }
      alerts.success('The file download will start momentarily.');
      const contentDisposition = responseData.headers('Content-Disposition');

      const reverseFileName = vm.downloadName.split('').reverse().join('');
      if (reverseFileName.indexOf('.') < 0 && !R.isNil(contentDisposition)) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
        vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
        vm.downloadName = vm.downloadName.split('"').join('');
      }
      const blob = new Blob(
        [responseData.data],
        { type: vm.mimeType, }
      );
      // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
      } else {
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.setAttribute('type', 'hidden');

        anchor.href = URL.createObjectURL(blob);
        anchor.download = vm.downloadName;
        anchor.target = '_self';
        anchor.click();
      }
    });
  }

  function cleanseDownloadName() {
    if ((vm.downloadName !== undefined) && (vm.downloadName.length > 5) && (vm.downloadName.indexOf('.') > 0)) {
      vm.downloadName = vm.downloadName.replaceAll('.', '_');
    }
  }
}

DownloadDocumentDirectiveController.$inject = [
  '$q',

  'alerts',
  'orgDataService'
];
